export default __webpack_public_path__ + "static/media/pc_background_addtext@2x.addde48a.png";